import {SET_STORAGE_TIMESTAMP, REMOVE_STORAGE} from '../actionTypes';

export function saveToStorage(){
    return {
        type: SET_STORAGE_TIMESTAMP,
        timestamp: new Date().getTime()
    }
}

export function removeStorage(){
    return {
        type: REMOVE_STORAGE
    }
}


// WEBPACK FOOTER //
// ./src/actions/common/storageActions.js